import {Attribute} from "../types/Attribute";
import {CustomAttribute} from "../types/CustomAttribute";
import {EventNames} from "../types/EventNames";
import {userComUserengage} from "../user_com_userengage";
import {updateUserAttributes} from "./update_user_attributes";

export const userAttachmentDownload = (params: {email: string; emailOptIn?: boolean; attachmentTitle: string}) => {
    const payload = {
        event_name: EventNames.UserArticleAttachmentDownload,
        [Attribute.EMAIL]: params.email,
        [CustomAttribute.ARTICLE_ATTACHMENT_TITLE]: params.attachmentTitle,
        ...(params.emailOptIn ? {[CustomAttribute.EMAIL_MARKETING_CONSENT]: "tak"} : {})
    };

    userComUserengage(EventNames.UserArticleAttachmentDownload, payload);
    updateUserAttributes(payload);
};
import {Attribute} from "../types/Attribute";
import {CustomAttribute} from "../types/CustomAttribute";
import {EventNames} from "../types/EventNames";
import {userComUserengage} from "../user_com_userengage";
import {updateUserAttributes} from "./update_user_attributes";

export const userAttachmentDownload = (params: {email: string; emailOptIn?: boolean; attachmentTitle: string}) => {
    const payload = {
        event_name: EventNames.UserArticleAttachmentDownload,
        [Attribute.EMAIL]: params.email,
        [CustomAttribute.ARTICLE_ATTACHMENT_TITLE]: params.attachmentTitle,
        ...(params.emailOptIn ? {[CustomAttribute.EMAIL_MARKETING_CONSENT]: "tak"} : {})
    };

    userComUserengage(EventNames.UserArticleAttachmentDownload, payload);
    updateUserAttributes(payload);
};
